import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Upload, Modal,   } from 'antd';
import {  LineOutlined,DoubleRightOutlined,DoubleLeftOutlined} from '@ant-design/icons';


const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function disabledDate(current) {
  // Can not select days before today and today
   return current && current > moment().endOf('Week');
}


function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

const dateFormat = 'YYYY-MM-DD';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

function yearDiff(dt1, dt2) 
 {
 
  var diffYear =(dt2.getTime() - dt1.getTime()) / 1000;
   diffYear /= (60 * 60 * 24);
  return Math.abs(Math.round(diffYear/365.25));
   
 }

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			city_list: [],
			state_list: [],
			loading: false,
			user_id: '',
			name: '',
			assign_label: '',
			primary_mobile: '',
			old_primary_mobile: '',
			secondary_mobile: '',
			email: '',
			old_email: '',
			locality: '',
			city: '',
			relation: '',
			child_name: '',
			gender: '',
			birthday: '',
			age: '',
			program_intrested: '',
			notes: '',
			date_of_enquiry: '',
			follow_up_date: '',
			how_know: '',
			source_type: '',
			referral_parent: '',
			reason: '',
			currentDate: '',
			academic_year: '',
			attend_school: 'No',
			attend_school_name: '',
			is_important: 0,
			school_list: [],
			academic_year_: [],
			manage_class: [],
			place_search: [],
			search_latitude: '',
			search_longitude: '', 
			search_addr:'',
			enq_type: 'external',
			tag_name: [],
			all_school_list: [],
			int_school_id:'',
			source_list: [],
			source_type_list: [],
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);	
		this.onChangebirthday = this.onChangebirthday.bind(this);	
		this.onChangejoin = this.onChangejoin.bind(this);	
		this.change_blood_group = this.change_blood_group.bind(this);	
		this.change_label = this.change_label.bind(this);	
		this.change_gender = this.change_gender.bind(this);	
		this.change_type = this.change_type.bind(this);	
		this.change_relation = this.change_relation.bind(this);	
		this.change_program = this.change_program.bind(this);	
		this.change_how_know = this.change_how_know.bind(this);	
		this.change_how_know_1 = this.change_how_know_1.bind(this);	
		this.change_attend = this.change_attend.bind(this);	
		this.change_year = this.change_year.bind(this);	
		this.onChangeenquiry = this.onChangeenquiry.bind(this);	
		this.onChangefollow = this.onChangefollow.bind(this);	
		
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.goBack = this.goBack.bind(this);	
		
		this.change_state = this.change_state.bind(this);	
		this.change_city = this.change_city.bind(this);	
		this.handlenext = this.handlenext.bind(this);	
		
		this.change_school_name = this.change_school_name.bind(this);	
	}
	
	change_school_name(event){
        this.setState({int_school_id: event});		 
		//document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
     }

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id,school_id : storedArray['data'][0]['school_id'] });
		this.checkData();
		}
		
		
		var date = new Date();
		var  currentDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
		this.setState({ currentDate : currentDate });
		
		
		
		
		
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ 
			 user_id : storedArray['data'][0]['user_id'], 
			 id : this.props.match.params.id, 
			 });
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			let id = this.props.match.params.id;
			var type = 8;
			var app = {user_id : user_id,id:id,school_id:school_id,type:type}
			getData('erp/enquiries_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							first_name: result['data'][0]['first_name'],
							last_name: result['data'][0]['last_name'],
							assign_label: result['data'][0]['assign_label'],
							primary_mobile: result['data'][0]['primary_mobile'],
							old_primary_mobile: result['data'][0]['primary_mobile'],
							secondary_mobile: result['data'][0]['secondary_mobile'],
							email: result['data'][0]['email'],
							old_email: result['data'][0]['email'],
							locality: result['data'][0]['locality'],
							search_latitude: result['data'][0]['latitude'],
							search_longitude: result['data'][0]['longitude'],
							search_addr: result['data'][0]['locality'],
							city: result['data'][0]['city'],
							state: result['data'][0]['state'],
							relation: result['data'][0]['relation'],
							child_first_name: result['data'][0]['child_first_name'],
							child_last_name: result['data'][0]['child_last_name'],
							gender: result['data'][0]['gender'],
							birthday: result['data'][0]['birthday'],
							program_intrested: result['data'][0]['program_intrested'],
							notes: result['data'][0]['notes'],
							date_of_enquiry: result['data'][0]['date_of_enquiry'],
							remark: result['data'][0]['remark'],
							follow_up_date: result['data'][0]['follow_up_date'],
							how_know: result['data'][0]['how_know'],
							source_type: result['data'][0]['source_type'],
							referral_parent: result['data'][0]['referral_parent'],
							reason: result['data'][0]['reason'],
							attend_school: result['data'][0]['attend_school'],
							attend_school_name: result['data'][0]['attend_school_name'],
							academic_year: result['data'][0]['academic_year'],
							is_important: result['data'][0]['is_important'],
							enq_type: result['data'][0]['type'],
							int_school_id: result['data'][0]['int_school_id'],
						});
						var date = new Date();
						var  currentDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
						
						var dt1 = new Date(currentDate);
						var dt2 = new Date(result['data'][0]['birthday']);
						var year_differnece = yearDiff(dt1, dt2);
						this.setState({
							age: year_differnece,
						});
						
					}else{
						this.setState({
							school_list: [],
						});
					}
				}
			});
	}
	getData('highschool/state_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							state_list: result['data'],
						});
					}else{
						this.setState({
							state_list: [],
						});
					}
				}
			});	
	    getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});
			getData('common/all_school_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							all_school_list: result['data'],
						});
					}else{
						this.setState({
							all_school_list: [],
						});
					}
				}
			});
			getData('common/source_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							source_list: result['data'],
						});
					}else{
						this.setState({
							source_list: [],
						});
					}
				}
			});
			getData('common/source_type_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							source_type_list: result['data'],
						});
					}else{
						this.setState({
							source_type_list: [],
						});
					}
				}
			});
			getData('erp/program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							manage_class: result['data'],
						});
					}else{
						this.setState({
							manage_class: [],
							
						});
					}
				}
			});	
			getData('erp/tag_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							tag_name: result['data'],
						});
					}else{
						this.setState({
							school_list: [],
							tag_name: '',
							
						});
					}
				}
			});			
  }
	
	onChangebirthday(date, dateString) {
	  var dt1 = new Date(this.state.currentDate);
	  var dt2 = new Date(dateString);
      var year_differnece = yearDiff(dt1, dt2);
	 
	
		this.setState({ birthday: dateString,age:year_differnece });
		document.getElementsByClassName('ant-calendar-picker-input')[0].classList.remove("error_focus");
	}
	
	onChangeenquiry(date, dateString) {
	  this.setState({ date_of_enquiry: dateString });
	}
	
	onChangefollow(date, dateString) {
	  this.setState({ follow_up_date: dateString });
	}
	
	onChangejoin(date, dateString) {
	  this.setState({ date_of_enquiry: dateString });
	}
	
	change_gender(event){
        this.setState({gender: event});
		document.getElementsByClassName('ant-select-selection')[4].classList.remove("error_focus");
     }
	 
	change_label(event){
        this.setState({assign_label: event});
		document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
    }
	
	change_type(event){
        this.setState({enq_type: event});		 
		//document.getElementsByClassName('ant-select-selection')[0].classList.remove("error_focus");
     }
	 
	change_relation(event){
        this.setState({relation: event});
		document.getElementsByClassName('ant-select-selection')[3].classList.remove("error_focus");
    }
	 
	change_program(event){
         this.setState({program_intrested: event});
		document.getElementsByClassName('ant-select-selection')[5].classList.remove("error_focus");
    }
	 
	change_how_know(event){
        this.setState({how_know: event});
		document.getElementsByClassName('ant-select-selection')[6].classList.remove("error_focus");
    }
	 
	change_how_know_1(event){
        this.setState({source_type: event});
		//document.getElementsByClassName('ant-select-selection')[6].classList.remove("error_focus");
    }
	
	change_attend(event){
         this.setState({attend_school: event});
		//document.getElementsByClassName('ant-select-selection')[6].classList.remove("error_focus");
     }
	 
	change_year(event){
        this.setState({academic_year: event});
		document.getElementsByClassName('ant-select-selection')[7].classList.remove("error_focus");
    }
	 
	change_blood_group(event){
         this.setState({blood_group: event});
     }
	 
	change_state(event){
         this.setState({state: event});
		 var app = {user_id : this.state.user_id,state_id:event}
			getData('highschool/city_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							city_list: result['data'],
						});
					}else{
						this.setState({
							city_list: [],
						});
					}
				}
			});		
		 
    }
	
	change_city(event){
        this.setState({city: event});
		document.getElementsByClassName('ant-select-selection')[2].classList.remove("error_focus");
    } 
	
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		if(e.target.name){
			document.getElementsByName(e.target.name)[0].classList.remove("error_focus");
		}
	}
	  
	  handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		var address   = document.getElementById('search_addr').value;
		var latitude  = document.getElementById('search_latitude').value;
		var longitude = document.getElementById('search_longitude').value;
		var id = this.props.match.params.id;
		var app = {
			id : id,
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			first_name : this.state.first_name,
			last_name : this.state.last_name,
			assign_label : this.state.assign_label,
			primary_mobile : this.state.primary_mobile,
			old_primary_mobile : this.state.old_primary_mobile,
			secondary_mobile : this.state.secondary_mobile,
			email : this.state.email,
			old_email : this.state.old_email,
			locality : address,
			latitude : latitude,
			longitude : longitude,
			state : this.state.state,
			city : this.state.city,
			relation : this.state.relation,
			child_first_name : this.state.child_first_name,
			child_last_name : this.state.child_last_name,
			gender : this.state.gender,
			birthday : this.state.birthday,
			program_intrested : this.state.program_intrested,
			how_know : this.state.how_know,
			source_type : this.state.source_type,
			referral_parent : this.state.referral_parent,
			reason : this.state.reason,
			attend_school: this.state.attend_school,
			attend_school_name: this.state.attend_school_name,
			academic_year : this.state.academic_year,
			date_of_enquiry : this.state.date_of_enquiry,
			remark : this.state.remark,
			sms : this.state.sms,
			type : this.state.enq_type,
			int_school_id : this.state.int_school_id,
		}
		getData('erp/edit_enquiry',app).then((result) => {
		if(result.status==400){
            message.config({ top: 150});
			message.error(result.error_msg,2);
			if(result.error_name=='' && result.error_key!=''){
				if(result.error_key=='birthday'){
					document.getElementsByClassName('ant-calendar-picker-input')[0].classList.add("error_focus");
				}
				else{
					document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
				} 					
			}
			else{					
				if(result.error_name!=''){
					document.getElementsByName(result.error_name)[0].classList.add("error_focus");
				}					
			}
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Enquiry Updated',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
              window.location.href = '/enquiries';
              //this.checkdata();

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
  
  handlenext=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		//this.setState({ loading: true });
		var address   = document.getElementById('search_addr').value;
		var latitude  = document.getElementById('search_latitude').value;
		var longitude = document.getElementById('search_longitude').value;
		var id = this.props.match.params.id;
		var app = {
			id : id,
			user_id : this.state.user_id,
			school_id : this.state.school_id,
			first_name : this.state.first_name,
			last_name : this.state.last_name,
			assign_label : this.state.assign_label,
			primary_mobile : this.state.primary_mobile,
			old_primary_mobile : this.state.old_primary_mobile,
			secondary_mobile : this.state.secondary_mobile,
			email : this.state.email,
			old_email : this.state.old_email,
			locality : address,
			latitude : latitude,
			longitude : longitude,
			state : this.state.state,
			city : this.state.city,
			relation : this.state.relation,
			child_first_name : this.state.child_first_name,
			child_last_name : this.state.child_last_name,
			gender : this.state.gender,
			birthday : this.state.birthday,
			program_intrested : this.state.program_intrested,
			how_know : this.state.how_know,
			source_type : this.state.source_type,
			referral_parent : this.state.referral_parent,
			reason : this.state.reason,
			attend_school: this.state.attend_school,
			attend_school_name: this.state.attend_school_name,
			academic_year : this.state.academic_year,
			date_of_enquiry : this.state.date_of_enquiry,
			remark : this.state.remark,
			sms : this.state.sms,
			int_school_id : this.state.int_school_id,
		}
		getData('erp/edit_enquiry',app).then((result) => {
		if(result.status==400){
            message.config({ top: 150});
			message.error(result.error_msg,2);
			if(result.error_name=='' && result.error_key!=''){
				if(result.error_key=='birthday'){
					document.getElementsByClassName('ant-calendar-picker-input')[0].classList.add("error_focus");
				}
				else{
					document.getElementsByClassName('ant-select-selection')[result.error_key].classList.add("error_focus");
				} 					
			}
			else{					
				if(result.error_name!=''){
					document.getElementsByName(result.error_name)[0].classList.add("error_focus");
				}					
			}
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Enquiry Updated',2);
              this.setState({ loading: false });
              this.setState({comment_text:''});
               var id = result.id;
			  var link = '/admissions/add-admissions/'+id;
              window.location.href = link;

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
  
  onGetPlaceList = (e) => {
		var app = {search : e.target.value}
		getData('auth/place_search',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						place_search: result['data'],
					});
				}else{
					this.setState({
						place_search: [],
					});
				}
			}
		});
	}
	
	onSetPlace = (title,lat,lng) => {
		const $ = window.$;
		document.getElementById('search_latitude').value = lat;
		document.getElementById('search_longitude').value = lng;
		document.getElementById('search_addr').value = title;
		document.getElementById('search_location').value = title;
		this.setState({locality:title,place_search:[]});
	}
  
  goBack(){
		window.location.href = '/admissions/enquiries';
	}

  
  
  
  
  

	render()

	{
	
	const { size } = this.state;
	const { previewVisible, previewImage, fileList, previewTitle } = this.state;
     
					
		return (
		<>
			
			
			<div class="mobile_view">
			
			<div class="row bred">
			<div class="col-md-12">
			<div class="card">
			<div class="card-body">
				<h4 class="page-title"> 
					<i class="mdi mdi-apple-keyboard-command title_icon"></i>Edit Enquiry
					
					<div class="breadcrumb-wrapper">
						<ol class="breadcrumb">
							<li class="breadcrumb-item">
								<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
								<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
								</a>
							</li>
							<li class="breadcrumb-item"> <a href={`${process.env.PUBLIC_URL}/enquiries`} class="router-link-active" target="_self">Enquiries</a> </li>
							<li class="breadcrumb-item"> Edit Enquiry </li>
						</ol>
					</div>
				</h4>
			</div>
			</div>
			</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
		 
            {this.state.school_list.map((list) => (
            <div class="col-md-12  ex-padd">
			
			
			
			
			<div class="view-Profile view-Profile-mobile child-profile ">
			   <div class="mb-20 card-content iq-card">
                  <section class="invoice-list-wrapper section food  ">
					<div class="children mb-2 iq-card2 flow-root">
                     
						<div class="bb d-flex">
						  
						  <div class="col col-md-12 s12 fees form-group mt-2">
								<div class="row">
								<div class="col-md-6 mt-10  mb-20">
									<label>Child Last Name</label>
									<input type="text" name="child_first_name" class="form-control" id="child_name" defaultValue={this.state.child_first_name} onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-6  mt-10 mb-20">
									<label>Child First Name</label>
									<input type="text" name="child_last_name" class="form-control" id="child_last_name" defaultValue={this.state.child_last_name} onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-4 mb-20">
									<label>Gender</label>
									<Select onChange={this.change_gender} defaultValue={list.gender}>
										<Select.Option value="Male">Male</Select.Option>
										<Select.Option value="Female">Female</Select.Option>
										<Select.Option value="Other">Other</Select.Option>
									</Select>
								</div>	
								
								
								<div class="col-md-4 mb-20">
									<label>Birthday</label>
									<DatePicker onChange={this.onChangebirthday} defaultValue={moment(list.birthday, dateFormat) } format={dateFormat} disabledDate={disabledDate}/>
								</div>	
								<div class="col-md-4 mb-10">
									<label>Age</label>
									<input type="text" name="age" id="age" class="form-control" value={this.state.age} disabled/>
								</div>
								<div class="col-md-4 mb-20">
									<label>Type</label>
									<Select onChange={this.change_type} value={this.state.enq_type}>
										<Select.Option value='internal'>Internal</Select.Option>
										<Select.Option value='external'>External</Select.Option>
									</Select>
								</div>
								
								{this.state.enq_type == 'internal' && (<>
								<div class="col-md-6 mb-20">
									<label>School Name</label>
									<Select onChange={this.change_school_name} value={this.state.int_school_id}>
										{this.state.all_school_list.map((list)=>(
										<Select.Option value={list.erp_id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>	
								</>)}
								
								<div class="col m4  s12 mb-20">
									<label>Assign Label</label>
									<Select onChange={this.change_label} defaultValue={list.assign_label}>
										{this.state.tag_name.map((list)=>(
										<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
										
									</Select>
								</div>	
								
								{(this.state.assign_label == 'Lost' || this.state.assign_label == 'Potential for Now' || this.state.assign_label == 'Potential for furthur' ) && (<>
								<div class="col-md-4    mb-20 ">
									<label>{this.state.assign_label} Reason</label>
									<input type="text" class="form-control"  name="reason" onChange={this.handleSizeChange}   required/>
									
								</div>	
								</>)}
								
								<div class="col-md-4  mb-20">
									<label>Primary Mobile</label>
									<input defaultValue={this.state.primary_mobile} class="form-control" type="text" name="primary_mobile" id="primary_mobile" onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-4  mb-20">
									<label>Secondary Mobile</label>
									<input defaultValue={this.state.secondary_mobile} class="form-control" type="text" name="secondary_mobile" id="secondary_mobile" onChange={this.handleSizeChange}   required/>
								</div>
								
								<div class="col-md-4  mb-10">
									<label>Email</label>
									<input type="text" name="email" class="form-control" defaultValue={this.state.email} id="email" onChange={this.handleSizeChange}   required/>
								</div>
								<div class="col-md-4  mb-10">
									<label>Locality</label>
									<input type="text" defaultValue={this.state.locality} name="locality" id="search_location" onChange={this.onGetPlaceList}  required/>
									<input type="text" defaultValue={this.state.search_latitude} class="hide" id="search_latitude" readOnly/>
									<input type="text" defaultValue={this.state.search_longitude} class="hide" id="search_longitude" readOnly/>
									<input type="text" defaultValue={this.state.search_addr} class="hide" id="search_addr" readOnly/>
									{(() => {
									   if (this.state.place_search.length>0 ) {
									   return (
										<>
											<div class="place-list">
											<ul>
											{this.state.place_search.map((data) => (
											<>
												<li onClick={this.onSetPlace.bind(this,data.title,data.lat,data.lng)}>{data.title}</li>
											</>
											))}
											</ul>
											</div>
										</>
									   )	
									 }
									})()}
								</div>
								<div class="col-md-4  mb-20">
									<label>State</label>
									<Select onChange={this.change_state} defaultValue={list.state_name} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
										{this.state.state_list.map((list) => (	
										<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								<div class="col-md-4  mb-20">
									<label>City</label>
									<Select onChange={this.change_city} defaultValue={list.city_name} showSearch filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
										{this.state.city_list.map((list) => (	
										<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								<div class="col-md-4 mb-20">
									<label>Relation With Child</label>
									<Select onChange={this.change_relation} defaultValue={list.relation}>
										<Select.Option value="Father">Father</Select.Option>
										<Select.Option value="Mother">Mother</Select.Option>
										<Select.Option value="Guardian">Guardian</Select.Option>
									</Select>
								</div>
								<div class="col-md-4  mb-20">
									<label>{this.state.relation} First Name</label>
									<input type="text" name="first_name" id="first_name" class="form-control" defaultValue={this.state.first_name} onChange={this.handleSizeChange}   required/>
								</div>	
								<div class="col-md-4   mb-20">
									<label>{this.state.relation} Last Name</label>
									<input type="text" name="last_name" id="last_name" class="form-control" defaultValue={this.state.last_name} onChange={this.handleSizeChange}   required/>
								</div>	
								
								
								<div class="col-md-4 mb-20">
									<label>Program Interested</label>
									<Select onChange={this.change_program} defaultValue={list.program_name}>
										{this.state.manage_class.map((list) => (
													<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
									
								</div>
								
								<div class="col-md-4 mb-20">
									<label>How you got to know about us?</label>
									<Select onChange={this.change_how_know}  defaultValue={list.how_know}>
										{this.state.source_list.map((list) => (	
										<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								
								<div class="col-md-4 mb-20">
									<label>Source Type</label>
									<Select onChange={this.change_how_know_1} defaultValue={list.source_type}>
										{this.state.source_type_list.map((list) => (	
										<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
									</Select>
								</div>
								
								{this.state.how_know == 'Parent Referral' && (<>
								<div class="col-md-4    mb-20 ">
									<label>Referral Parent Name</label>
									<input type="text" class="form-control"  name="referral_parent" onChange={this.handleSizeChange} value={this.state.referral_parent}  required/>
								</div>	
								</>)}
								
								<div class="col-md-4 mb-20">
									<label>Did The Child Attend Any School</label>
									<Select onChange={this.change_attend} defaultValue={list.attend_school}>
										<Select.Option value="No">No</Select.Option>
										<Select.Option value="Yes">Yes</Select.Option>
									</Select>
								</div>
								
								{this.state.attend_school == 'Yes' && (<>
								<div class="col-md-4    mb-20 ">
									<label>Attend School Name</label>
									<input type="text" class="form-control" value={this.state.attend_school_name}  name="attend_school_name" onChange={this.handleSizeChange}   required/>
								</div>	
								</>)}
								
								<div class="col-md-4 mb-10 pb-20">
									<label>Academic Year</label>
									<Select onChange={this.change_year} value={this.state.academic_year}>	
										 <Select.Option value="">Select Academic Year</Select.Option>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
									</Select>
								</div>	

								<div class="col-md-4 mb-20">
									<label>Date Of Enquiry</label>
									<DatePicker onChange={this.onChangeenquiry} defaultValue={moment(list.date_of_enquiry, dateFormat) } disabledDate={disabledDate} />
								</div>	
								<div class="col-md-8 mb-20">
									<label>Remark</label>
									<input type="text" class="form-control"  name="remark" value={this.state.remark} onChange={this.handleSizeChange}   required/>
								</div>		
								</div>

									
						  </div>
						</div>
							
						
					</div> 
					
						
					
					
						
					
					
					<div class="col-md-12 s12 meal mb-10 text-center">
						 <Button className="btn btn-primary mr-2" onClick={this.handleSubmit} loading={this.state.loading}>Submit</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
			))}
         </div>
      </div>
     
			</div>
		</>	
		) 
	} 
}
export default Index;
